<script setup lang="ts">
import { ref } from 'vue';
import useScrollLock from './hooks/useScrollLock';

defineProps<{
    tabs: { label: string; value: string }[];
}>();

const modelValue = defineModel<string>({ required: true });

const handleClick = (value: string) => {
    modelValue.value = value;
};

// 获取容器元素引用
const containerRef = ref<HTMLElement | null>(null);
// 应用横向滚动逻辑
useScrollLock(containerRef);
</script>

<template>
    <div class="tabs" ref="containerRef">
        <div
            v-for="tab in tabs"
            :key="tab.value"
            class="tab-item"
            :class="{ active: tab.value === modelValue }"
            @click="handleClick(tab.value)"
        >
            {{ tab.label }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.tabs {
    display: flex;
    gap: 16px;
    padding: 4px 16px 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    overflow-x: auto;
    overflow-y: hidden;

    --tab-text-color: rgba(0, 0, 0, 0.54);
    --tab-active-color: rgba(0, 0, 0, 0.9);
    --tab-border-color: rgba(0, 0, 0, 0.9);

    /* 隐藏滚动条 - Webkit 内核 (Chrome, Safari, WebView) */
    &::-webkit-scrollbar {
        display: none;
    }

    @media (prefers-color-scheme: dark) {
        --tab-text-color: rgba(255, 255, 255, 0.54);
        --tab-active-color: rgba(255, 255, 255, 0.9);
        --tab-border-color: rgba(255, 255, 255, 0.9);
    }

    .tab-item {
        flex-shrink: 0;
        min-width: 32px;
        max-width: 70vw;
        padding: 9px 0px;
        font-size: 16px;
        color: var(--tab-text-color);
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        font-weight: 400;

        /* 移除移动端默认的触摸高亮 */
        -webkit-tap-highlight-color: transparent;

        &.active {
            color: var(--tab-active-color);
            padding: 9px 0px 7px;
            font-weight: 500;
            border-bottom: 2px solid var(--tab-border-color);
        }
    }
}
</style>
